import { Link } from "react-router-dom"
import styles from "./style.module.css"
import Instagram from "assets/images/svg/Frame-2.svg";
import Facebook from "assets/images/svg/Frame-1.svg";
import linkedin from "assets/images/svg/Frame.svg";
import twitter from "assets/images/svg/Group (2).svg";
import mail from "assets/images/svg/Vector.svg";
import vector from "assets/images/svg/Frame3.svg";
import logo from "assets/images/svg/Logo.svg";

const Footer = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.footerContent}>
          {/* Logo and Description */}
          <div className={styles.logoSection}>
            <img src={logo} alt="IEEE Logo" className={styles.logo} />
            <p className={styles.description}>
              The IEEE Kafrelsheikh Student Branch is the leading organization in Kafrelsheikh city that works to build,
              innovate and inspire the technical community
            </p>
            <div className={styles.socialLinks}>
                <a href="https://www.instagram.com/ieee_ksb?igsh=MWNjdW02NThyZ2JnMA==" className={styles.socialLink} target="_blank" rel="noopener noreferrer">
                  <img src={Instagram} alt="Instagram" />
                </a>
                <a href="https://www.facebook.com/share/15xxpedjvt/?mibextid=wwXIfr" className={styles.socialLink} target="_blank" rel="noopener noreferrer">
                  <img src={Facebook} alt="Facebook" />
                </a>
                <a href="https://www.linkedin.com/company/ieee-kafrelshiekh-student-branch/" className={styles.socialLink} target="_blank" rel="noopener noreferrer">
                  <img src={linkedin} alt="LinkedIn" />
                </a>
                <a href="https://twitter.com/" className={styles.socialLink} target="_blank" rel="noopener noreferrer">
                  <img src={twitter} alt="Twitter" />
                </a>
              </div>
          </div>

          {/* Sitemap */}
          <div className={styles.sitemapSection}>
            <h3 className={styles.sectionTitle}>Sitmap</h3>
            <div className={styles.linksGrid}>
              <div className={styles.linksColumn}>
                <Link to="/" className={styles.link}>
                  Home
                </Link>
                <Link to="/about" className={styles.link}>
                  About
                </Link>
                <Link to="/team" className={styles.link}>
                  Team
                </Link>
              </div>
              <div className={styles.linksColumn}>
                <Link to="/events" className={styles.link}>
                  Events
                </Link>
                <Link to="/forms" className={styles.link}>
                  Forms
                </Link>
              </div>
            </div>
          </div>

          {/* Join The Family */}
          <div className={styles.joinSection}>
            <h3 className={styles.sectionTitle}>Join The Family</h3>
            <p className={styles.joinText}>Sign-up for the latest news, offers, and much more.</p>
            <div className={styles.emailContainer}>
              <div className={styles.inputWrapper}>
                <span className={styles.emailIcon}>
                  <img src={mail} alt="Email" />
                </span>
                <input type="email" placeholder="Enter your email" className={styles.emailInput} />
              </div>
              <button className={styles.submitButton}>
                <img src={vector} alt="Submit" />
              </button>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className={styles.copyright}>
            <p>
              <span>2023 IEEE | All Rights Reserved - Developed by </span>
              <a href="https://portfolio-psi-two-81.vercel.app/" className={styles.developerLink} target="_blank" rel="noopener noreferrer">
                Mohamed Samy
              </a>
            </p>
          </div>
      </div>
    </footer>
  )
}

export default Footer

